import React from 'react'

function Login() {
  return (
    <h2>Please login to see this page</h2>
  )
}

export default Login